import type { MarketConfiguration } from "./const";
import {
  ContentfulEnum,
  CurrencyEnum,
  ElevateMarketEnum,
  LocaleEnum,
  MarketEnum,
  RegionEnum,
  ServiceLocaleEnum,
} from "./const";

const hungary: MarketConfiguration = {
  code: MarketEnum.hu,
  label: "Hungary",
  descriptiveLabel: "Hungarian",
  contentfulLocale: ContentfulEnum.en,
  contentfulCountry: "Hungary",
  locale: LocaleEnum.hu,
  serviceLocale: ServiceLocaleEnum.hu,
  language: {
    code: "en",
    label: "English",
    flag: "gb",
  },
  currency: CurrencyEnum.eur,
  link: "https://www.no-ga.com/en-hu",
  termsSlug: "terms-online",
  loop54Market: MarketEnum.hu,
  adyenMarket: MarketEnum.hu,
  elevateMarket: ElevateMarketEnum.eu,
  freeShippingThreshold: 100,
  freeShippingEnabled: false,
  externalStoreId: "ecom-noga",
  searchPathName: "search",
  adyenCheckoutEnabled: true,
  walleyCheckoutEnabled: false,
  hasTrustPilot: false,
  region: RegionEnum.europe,
  norceImageCdn: ["local", "dev", "stage"].includes(
    process.env.NEXT_PUBLIC_ENVIRONMENT ?? "",
  )
    ? "https://media.stage.cdn-norce.tech/1413"
    : "https://cdn.no-ga.com",
};

export default hungary;
